import { CalcAnatomyCores } from "./index51.js";
import { getActiveBuildings } from "./index183.js";
const pipeCalcAnatomyCores = ([parent, { buildingIds, aggProps }]) => {
  const dataset = aggProps.dataset;
  const buildings = getActiveBuildings(parent, aggProps);
  for (const building of buildings) {
    if (buildingIds && !buildingIds.includes(building.uuid))
      continue;
    CalcAnatomyCores(building.data.anatomy, dataset);
  }
  return [parent, void 0];
};
export {
  pipeCalcAnatomyCores
};
//# sourceMappingURL=index99.js.map
